import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthenticationService } from '../../core/services/auth.service';

@Injectable({ providedIn: 'root' })
export class PermissionGuard implements CanActivate {
    constructor(private authService: AuthenticationService, private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const requiredPermissions = route.data['permissions'] as string[];
        //const requiredRole = route.data['role'] as string;

        // V�rifier le r�le si d�fini
        /*if (requiredRole && !this.authService.hasRole(requiredRole)) {
            this.router.navigate(['/unauthorized']);
            return false;
        }*/

        // V�rifier les permissions si d�finies
        if (requiredPermissions && requiredPermissions.length > 0) {
            const hasAny = requiredPermissions.some(p => this.authService.hasPermission(p));
            if (!hasAny) {
                this.router.navigate(['/unauthorized']);
                return false;
            }
        }

        return true;
    }
}
